var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgValidatorFallback(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "validator_none_img",
    transform: "translate(-252 -625)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD0C0\\uC6D0_319",
    "data-name": "\\uD0C0\\uC6D0 319",
    transform: "translate(252 625)",
    fill: "#fff",
    stroke: "#e6e6e6",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_4623",
    "data-name": "\\uADF8\\uB8F9 4623",
    transform: "translate(17 -56.596)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1424",
    "data-name": "\\uD328\\uC2A4 1424",
    d: "M1765.3,1243.826a3.245,3.245,0,1,1,3.245-3.245A3.249,3.249,0,0,1,1765.3,1243.826Zm0-5.745a2.5,2.5,0,1,0,2.5,2.5A2.5,2.5,0,0,0,1765.3,1238.08Z",
    transform: "translate(-1515.262 -548.335)",
    fill: "#4b525d",
    stroke: "#4b525d",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1425",
    "data-name": "\\uD328\\uC2A4 1425",
    d: "M1752.4,1291.769h-12.448a.373.373,0,0,1-.373-.373,6.71,6.71,0,0,1,5.8-6.528.373.373,0,0,1,.417.453l-.606,2.606,1.026,1.026,1.028-1.028-.568-2.59a.373.373,0,0,1,.425-.448,6.736,6.736,0,0,1,5.671,6.508A.373.373,0,0,1,1752.4,1291.769Zm-12.062-.746h11.677a5.991,5.991,0,0,0-4.485-5.282l.488,2.224a.372.372,0,0,1-.1.343l-1.436,1.436a.373.373,0,0,1-.527,0l-1.436-1.436a.372.372,0,0,1-.1-.348l.524-2.25A5.963,5.963,0,0,0,1740.34,1291.023Z",
    transform: "translate(-1496.137 -588.777)",
    fill: "#4b525d",
    stroke: "#4b525d",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1426",
    "data-name": "\\uD328\\uC2A4 1426",
    d: "M1815.1,1250.545a2.351,2.351,0,1,1,2.351-2.352A2.354,2.354,0,0,1,1815.1,1250.545Zm0-3.957a1.606,1.606,0,1,0,1.606,1.606A1.608,1.608,0,0,0,1815.1,1246.588Z",
    transform: "translate(-1558.39 -555.574)",
    fill: "#4b525d",
    stroke: "#4b525d",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1427",
    "data-name": "\\uD328\\uC2A4 1427",
    d: "M1819.193,1285.859h-3.606a.373.373,0,0,1,0-.745h3.216a3.916,3.916,0,0,0-5.734-3.085.373.373,0,1,1-.35-.658,4.661,4.661,0,0,1,6.847,4.116A.373.373,0,0,1,1819.193,1285.859Z",
    transform: "translate(-1558.2 -585.341)",
    fill: "#4b525d",
    stroke: "#4b525d",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1428",
    "data-name": "\\uD328\\uC2A4 1428",
    d: "M1727.606,1250.545a2.351,2.351,0,1,1,2.352-2.352A2.354,2.354,0,0,1,1727.606,1250.545Zm0-3.957a1.606,1.606,0,1,0,1.606,1.606A1.608,1.608,0,0,0,1727.606,1246.588Z",
    transform: "translate(-1483.946 -555.574)",
    fill: "#4b525d",
    stroke: "#4b525d",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1429",
    "data-name": "\\uD328\\uC2A4 1429",
    d: "M1713.75,1285.859h-3.606a.373.373,0,0,1-.373-.373,4.661,4.661,0,0,1,6.847-4.116.373.373,0,0,1-.35.658,3.916,3.916,0,0,0-5.733,3.085h3.216a.373.373,0,1,1,0,.745Z",
    transform: "translate(-1470.77 -585.341)",
    fill: "#4b525d",
    stroke: "#4b525d",
    strokeWidth: 0.3
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidatorFallback);
export default __webpack_public_path__ + "static/media/validator_fallback.983ad4f48d419359dce599901ebb054c.svg";
export { ForwardRef as ReactComponent };